<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("createLots") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <div class="mobile_simple overflow-auto">
            <TableWithFilter
              child-key="items"
              :headers="headers"
              :items="items"
              :options="tableOptions"
              fixed-header
              handlerValue="code"
            >
              <template #filter.state>
                <div class="pa-1">
                  <VueSelect
                    @input="onChangeHandler"
                    clearable
                    v-model="lotListFilter.status"
                    :items="contractItemStatusList"
                  ></VueSelect>
                </div>
              </template>
              <template #filter.code>
                <div class="pa-1">
                  <CustomInputText
                    clearable
                    v-model="lotListFilter.code"
                    @input="onChangeHandler"
                    class="user_input no-margin"
                    type="text"
                  ></CustomInputText>
                </div>
              </template>
              <template #filter.conclusionDate>
                <div class="pa-1 d-flex align-center">
                  <span class="custom_input_label pt-1 pr-2">{{
                    $t("from")
                  }}</span>
                  <CustomDatePicker
                    :max="lotListFilter.toDate || new Date()"
                    @input="onChangeHandler"
                    clearable
                    v-model="lotListFilter.fromDate"
                    label=""
                    name="calendar"
                    class="user_input mr-2 data_item data_item_calendar"
                    icon="mdi-calendar-month small"
                  ></CustomDatePicker>
                  <span class="custom_input_label pt-1">{{ $t("to") }}</span>
                  <CustomDatePicker
                    :start-day="false"
                    @input="onChangeHandler"
                    clearable
                    :min="lotListFilter.fromDate"
                    :max="new Date()"
                    v-model="lotListFilter.toDate"
                    name="calendar_t"
                    color="#E3EBF3"
                    class="user_input data_input_tw ml-2 data_item"
                    icon="mdi-calendar-month small"
                  ></CustomDatePicker>
                </div>
              </template>

              <template #expandBtn="{ openHandler, item }">
                <TriangleBtn
                  :active="item.show"
                  :loading="item.loading"
                  @click="openHandler(item, getContractItems)"
                />
              </template>

              <!-- parent -->
              <template #item.conclusionDate="{ item }">{{
                item.conclusionDate | dateParse
              }}</template>
              <template #item.state="{ item }">
                <span class="font-weight-bold">{{
                  $t(`contractStatus.${item.state}`)
                }}</span>
              </template>
              <template #item.guessReceiveDate="{ item }">
                {{ item["guessReceiveDate"] | dateParse }}
              </template>

              <!-- child -->
              <template #child.action="{ item, child }">
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="
                    child.warehouseReceivedType ===
                      WAREHOUSE_RECEIVED_TYPE.PARTITION ||
                    !child.warehouseReceivedType
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="
                        openCreateIncomeDialog(
                          child.contractNumber,
                          child.productName,
                          child.acceptedCount,
                          child.receipt,
                          child.id
                        )
                      "
                    >
                      <vue-icon icon="newFileEdit" />
                    </VBtn>
                  </template>
                  <span>{{ $t("createIncome") }}</span>
                </VTooltip>
                <VTooltip
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                  v-if="
                    /**
                     * @type {Object}
                     * @property warehouseReceivedType
                     */
                    child.warehouseReceivedType ===
                      WAREHOUSE_RECEIVED_TYPE.LOT ||
                    !child.warehouseReceivedType
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <VBtn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="
                        openCreateLotsDialog(
                          child.contractNumber,
                          child.productName,
                          child.acceptedCount,
                          child.receipt,
                          child.id
                        )
                      "
                    >
                      <vue-icon icon="newFileUpdloadIcon" />
                    </VBtn>
                  </template>
                  <span>{{ $t("createLots") }}</span>
                </VTooltip>
              </template>
              <template
                #child.numb="{
                  child,
                  /**
                   * @type Object
                   * @property {string} contractItemNumb
                   */
                }"
                >{{ child.contractItemNumb }}</template
              >
              <template #child.state="{ child }">
                <span
                  class="font-weight-bold"
                  :style="{
                    color:
                      child.statusType === INITIATOR_STATUS_TYPE.ACCEPTED
                        ? '#36C281'
                        : child.statusType === INITIATOR_STATUS_TYPE.REJECTED
                        ? '#ee6565'
                        : child.statusType ===
                          INITIATOR_STATUS_TYPE.PART_ACCEPTED
                        ? '#01617F'
                        : '#FDCC05',
                  }"
                  >{{ $t(`contractStatus.${child.state}`) }}</span
                >
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child["itemGuessReceiveDate"] | dateParse }}
              </template>
              <template #child.unitType="{ child }">
                {{ child[`unit_type_name_${$i18n.locale}`] }}</template
              >
              <template #child.count="{ child }">{{ child.count }}</template>
              <template #child.acceptedCount="{ child }">{{
                child.acceptedCount
              }}</template>
              <template #child.rejectedCount="{ child }">{{
                child.rejectedCount
              }}</template>
              <template #child.leftToCapitalize="{ child }">{{
                child.acceptedCount - child.receipt
              }}</template>
              <template #child.orderItemNumb="{ child }">{{
                child.orderItemNumb
              }}</template>
              <template #child.productAttrs="{ child }">
                {{ child.attrs && child.attrs.join(" || ") }}
              </template>
            </TableWithFilter>
            <VuePagination
              go-to
              @update:limit="
                (limit) => {
                  configuration.limit = limit;
                  configuration.page = 1;
                  changePage();
                }
              "
              v-model="configuration.page"
              :length="lastPage"
              @input="changePage"
              :limit="configuration.limit"
            />
          </div>
        </div>
      </div>
    </div>
    <CreateIncomeDialog
      ref="createIncomeDialogRef"
      @updateTableData="getContracts"
    ></CreateIncomeDialog>
    <CreateLotsDialog
      ref="createLotsDialogRef"
      @updateTableData="getContracts"
    ></CreateLotsDialog>
  </div>
</template>

<script>
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter.vue";
import {
  dateFormat,
  INITIATOR_STATUS_TYPE,
  contractStatus,
  WAREHOUSE_RECEIVED_TYPE,
} from "@/utils/constants.js";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions.js";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import CreateIncomeDialog from "@/components/omtk/CreateIncomeDialog.vue";
import CreateLotsDialog from "@/components/omtk/CreateLotsDialog.vue";

const FilterOmtkLots = {
  code: null,
  fromDate: null,
  groupId: null,
  productName: null,
  status: null,
  toDate: null,
  typeId: null,
};
export default {
  components: {
    VuePagination,
    TableWithFilter,
    TriangleBtn,
    VueSelect,
    CreateIncomeDialog,
    CreateLotsDialog,
  },
  data() {
    return {
      lastPage: 0,
      items: [],
      lotListFilter: {
        ...FilterOmtkLots,
      },
      tableOptions: {
        sortBy: "conclusionDate",
        sortDirection: true,
      },
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    openCreateIncomeDialog(
      contractNumber,
      productName,
      acceptedCount,
      receipt,
      id
    ) {
      const { createIncomeDialogRef } = this.$refs;
      if (createIncomeDialogRef) {
        createIncomeDialogRef.open(
          contractNumber,
          productName,
          acceptedCount,
          receipt,
          id
        );
      }
    },
    openCreateLotsDialog(
      contractNumber,
      productName,
      acceptedCount,
      receipt,
      id
    ) {
      const { createLotsDialogRef } = this.$refs;
      if (createLotsDialogRef) {
        createLotsDialogRef.open(
          contractNumber,
          productName,
          acceptedCount,
          receipt,
          id
        );
      }
    },
    async getContractItems(item) {
      const { page, limit } = this.configuration;
      let params = {
        allReseived: false,
        contractId: item.id,
        forMobile: true,
        page: page - 1,
        limit,
      };
      const {
        data: { data },
      } = await this.$http.get("contract/list-item", {
        params,
      });
      if (data.length > 0) {
        item.items = data;
      }
    },
    async getContracts() {
      this.showLoading();
      try {
        const { page, limit } = this.configuration;
        let params = {
          page: page - 1,
          limit,
          forQrCodePrint: true,
          ...this.tableOptions,
          ...this.lotListFilter,
        };
        const {
          data: { data, total },
        } = await this.$http.get("contract/list", {
          params,
        });
        this.items = data.map((item) => {
          item.show = false;
          item.loading = false;
          item.items = null;
          return item;
        });
        this.lastPage = makerPagination({ total: total, limit }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        this.showLoading();
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
        await this.getContracts();
        this.clearLoading();
      }
    },
    onChangeHandler: debounce(function () {
      let filter = { ...this.lotListFilter };
      if (filter.fromDate)
        filter.fromDate = window.moment(filter.fromDate).format(dateFormat);
      if (filter.toDate)
        filter.toDate = window.moment(filter.toDate).format(dateFormat);
      this.getContractsByFilter();
    }, 500),
    async getContractsByFilter() {
      this.showLoading();
      this.configuration.page = 1;
      await this.getContracts();
      await this.$router
        .replace({
          query: { ...this.tableOptions, ...this.lotListFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    },
  },
  computed: {
    headers() {
      return [
        {
          value: "code",
          text: this.$t("contractNumber"),
          sortable: true,
        },
        {
          value: "state",
          text: this.$t("state"),
          sortable: false,
        },
        {
          value: "productName",
          text: this.$t("productName"),
          sortable: false,
        },
        {
          value: "orderItemNumb",
          text: this.$t("orderRequestItemNumber"),
          sortable: false,
        },
        {
          value: "unitType",
          text: this.$t("unit"),
          sortable: false,
        },
        {
          value: "productAttrs",
          text: this.$t("attributes"),
          sortable: true,
        },
        {
          value: "action",
          text: this.$t("action"),
          sortable: false,
        },
        {
          value: "count",
          text: this.$t("count"),
          sortable: false,
        },
        {
          value: "acceptedCount",
          text: this.$t("acceptedCount"),
          sortable: false,
        },
        {
          value: "rejectedCount",
          text: this.$t("rejectedCount"),
          sortable: false,
        },
        {
          value: "leftToCapitalize",
          text: this.$t("leftToCapitalize"),
          sortable: false,
        },
        {
          value: "rejectReasen",
          text: this.$t("reasonRejectContract"),
          sortable: false,
        },
        {
          value: "conclusionDate",
          text: this.$t("contractDate"),
          sortable: false,
        },
        {
          value: "guessReceiveDate",
          text: this.$t("guessReceiveDate"),
          sortable: false,
        },
        {
          value: "productTypeName",
          text: this.$t("typeProduct"),
          sortable: false,
        },
        {
          value: "supplierName",
          text: this.$t("supplier"),
          sortable: false,
        },
        {
          value: "supplyType",
          text: this.$t("typeSupply"),
          sortable: false,
        },
        {
          value: "productGroupName",
          text: this.$t("productGroup"),
          sortable: false,
        },
        {
          value: "receiverDate",
          text: this.$t("receiverDate"),
          sortable: false,
        },
        {
          value: "updateUser",
          text: this.$t("statusChangedUser"),
          sortable: false,
        },
      ];
    },
    INITIATOR_STATUS_TYPE: () => INITIATOR_STATUS_TYPE,
    contractStatus: () => contractStatus,
    WAREHOUSE_RECEIVED_TYPE: () => WAREHOUSE_RECEIVED_TYPE,
    contractItemStatusList() {
      return Object.keys(contractStatus).map((item) => {
        return {
          name: this.$t(`contractStatus.${item}`),
          id: item,
        };
      });
    },
  },
  async created() {
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (tableOptions.page) tableOptions.page = +tableOptions.page;
    if (tableOptions.sortDirection)
      tableOptions.sortDirection = trueSet(tableOptions.sortDirection);
    this.tableOptions = tableOptions;
    this.lotListFilter = getQueryByKey(FilterOmtkLots, query);
    this.showLoading();
    await Promise.all([this.getContracts()]);
    this.clearLoading();
  },
};
</script>
